import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark } from '@fortawesome/pro-solid-svg-icons';
import * as styles from './FilterBar.css';

type FilterChipProps = {
  displayText: string;
  onRemove: () => void;
};

export const FilterChip = ({ displayText, onRemove }: FilterChipProps) => {
  return (
    <span className={styles.chip}>
      {displayText}
      <button
        type="button"
        className={styles.chipRemoveButton}
        onClick={onRemove}
        aria-label={`Remove filter: ${displayText}`}
      >
        <FontAwesomeIcon icon={faXmark} size="xs" />
      </button>
    </span>
  );
};
